// import { getter } from "@progress/kendo-react-common";

import {
  INVALID,
  INVALID_EMAIL,
  INVALID_ID_NAME,
  INVALID_PASSPORT,
  INVALID_PHONE,
  INVALID_PINCODE,
  MAX_3_ITEM_VALIDATOR,
  MIN_LENGTH_INT_MOBILE,
  MIN_LENGTH_MOBILE,
  MIN_LENGTH_PWD,
  MINIMUM_2_CHAR,
  MINIMUM_3_CHAR,
  REQUIRED_FIELD,
  REQUIRED_FIELD_GREATERTHAN_0,
} from "../../_contstants/Messages";

const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
const phoneRegex: RegExp = new RegExp(/^\d{1,16}$/);
const ccardRegex: RegExp = new RegExp(/^[0-9-]+$/);
const cvcRegex: RegExp = new RegExp(/^[0-9]+$/);
const pincodeRegex = RegExp(/^[1-9][0-9]{3}$|^[1-9][0-9]{5}$/);
const GSTNoRegex = RegExp(
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
);
const PANNoRegex = RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
const PassportNoRegex = RegExp(/^[A-Z]{1}[0-9]{7}$/);
const idRegexPattern = RegExp(/^[A-Za-z_][A-Za-z0-9\-:._]{3,}$/);

export const requiredValidator = (value: any) => (value ? "" : REQUIRED_FIELD);

export const min2CharValidator = (value: string) =>
  value?.split("").length > 1 ? "" : MINIMUM_2_CHAR;

export const min3CharValidator = (value: string) =>
  value?.split("").length > 2 ? "" : MINIMUM_3_CHAR;

export const requiredValidatorNumber0 = (value: any) =>
  value ? (value === "0" ? REQUIRED_FIELD_GREATERTHAN_0 : "") : REQUIRED_FIELD;

export const reqValGreterThanNumber0 = (value: any) =>
  value ? (value >= 0 ? "" : REQUIRED_FIELD) : REQUIRED_FIELD;
export const htmlIdValidator = (value: string) =>
  !value ? REQUIRED_FIELD : idRegexPattern.test(value) ? "" : INVALID_ID_NAME;
export const MobileNoValidator = (value: string) =>
  value && value.length > 9 ? "" : MIN_LENGTH_MOBILE;
export const MobileNoWOValueValidator = (value: any) =>
  !value ? "" : value && value.length > 9 ? "" : MIN_LENGTH_MOBILE;
export const MobileNoIntValidator = (value: string) =>
  value && value.length > 3 ? "" : MIN_LENGTH_INT_MOBILE;
export const MobileNoIntWOValueValidator = (value: string) =>
  !value ? "" : value && value.length > 3 ? "" : MIN_LENGTH_INT_MOBILE;

export const requiredWOValueValidator = (value: any) =>
  !value ? "" : value ? "" : REQUIRED_FIELD;

export const minValidator = (value: any) =>
  parseInt(value) >= 0 ? "" : "Minimum 0 Required";

export const skipValidator = () => "";

export const requiredArrayValidator = (value: any) =>
  !value || value.length === 0 ? REQUIRED_FIELD : "";

export const max3ItemArrayValidator = (value: any) => {
  return !value || value?.length < 1
    ? REQUIRED_FIELD
    : value.length > 3
      ? MAX_3_ITEM_VALIDATOR
      : "";
};

export const max3WOItemArrayValidator = (value: any) => {
  return value?.length > 3 ? MAX_3_ITEM_VALIDATOR : "";
};

export const emailValidator = (value: string) =>
  !value ? REQUIRED_FIELD : emailRegex.test(value) ? "" : INVALID_EMAIL;

export const emailWOValueValidator = (value: string) =>
  !value ? "" : emailRegex.test(value) ? "" : INVALID_EMAIL;

export const passportValidator = (value: string) =>
  !value ? REQUIRED_FIELD : PassportNoRegex.test(value) ? "" : INVALID_PASSPORT;

export const passportWOValueValidator = (value: string) =>
  !value ? "" : PassportNoRegex.test(value) ? "" : INVALID_PASSPORT;

export const passwordValidator = (value: string) =>
  value && value?.length > 5 ? "" : MIN_LENGTH_PWD;

export const confirmPasswordValidator = (
  newPassword: string,
  confirmPassword: string,
) => {
  return newPassword === confirmPassword ? "" : "Passwords do not match";
};

export const pincodeValidator = (value: string) =>
  !value ? REQUIRED_FIELD : pincodeRegex.test(value) ? "" : INVALID_PINCODE;

export const pincodeWOValueValidator = (value: string) =>
  !value ? "" : pincodeRegex.test(value) ? "" : INVALID_PINCODE;

export const gstValidator = (value: string) =>
  !value ? REQUIRED_FIELD : GSTNoRegex.test(value) ? "" : INVALID;

export const gstWOValueValidator = (value: string) =>
  !value ? "" : GSTNoRegex.test(value) ? "" : INVALID;

export const panValidator = (value: string) =>
  !value ? REQUIRED_FIELD : PANNoRegex.test(value) ? "" : INVALID;

export const panWOValueValidator = (value: string) =>
  !value ? "" : PANNoRegex.test(value) ? "" : INVALID;

export const phoneValidator = (value: string) =>
  !value ? REQUIRED_FIELD : phoneRegex.test(value) ? "" : INVALID_PHONE;

export const phoneWOValueValidator = (value: string) =>
  !value ? "" : phoneRegex.test(value) ? "" : INVALID_PHONE;

export const userNameValidator = (value: string) =>
  !value
    ? "User Name is required"
    : value.length < 5
      ? "User name should be at least 5 characters long."
      : "";

export const cardValidator = (value: string) =>
  !value
    ? "Credit card number is required. "
    : ccardRegex.test(value)
      ? ""
      : "Not a valid credit card number format.";

export const cvcValidator = (value: string) =>
  !value
    ? "CVC code is required,"
    : cvcRegex.test(value) || value.length !== 3
      ? ""
      : "Not a valid CVC code format.";

export const requiredValidatorforBOOK = (value: any) =>
  value !== undefined && value !== null ? "" : REQUIRED_FIELD;
